'use strict';

var debounce = require('lodash/debounce');

$(() => {
    $('.js-view-more').on('click', (e) => {
        const $button = $(e.currentTarget);
        const $component = $button.closest('.right-section');
        const $campaignTextContent = $component.find('.campaign-header__text-block');
        $campaignTextContent.removeClass('truncate-text');
        $campaignTextContent.html($campaignTextContent.data('campaign-header-text'));
        $component.find('.view-more-cta').addClass('d-none');
        $component.find('.view-less-cta').removeClass('d-none');
    });

    /**
     * Limit the number of characters to display
     */
    function limitText() {
        var $campaignTextContent = $('.campaign-header__text-block');

        $campaignTextContent.each(function () {
            if ($campaignTextContent.hasClass('truncate-text')) {
                var $this = $(this);
                var $viewMoreCTA = $this.closest('.right-section').find('.view-more-cta');
                var mobileLimit = $this.data('mobile-limit');
                var tabletLimit = $this.data('tablet-limit');
                var desktopLimit = $this.data('desktop-limit');
                var textValue = $this.data('campaign-header-text');
                textValue = textValue && textValue.trim();
                var charLimit = desktopLimit;

                if (!app.checkBreakPoint('md') && mobileLimit) {
                    charLimit = mobileLimit;
                } else if (!app.checkBreakPoint('lg') && tabletLimit) {
                    charLimit = tabletLimit;
                }
                if (textValue.length > charLimit) {
                    textValue = textValue.substring(0, charLimit) + '...';
                    $viewMoreCTA.removeClass('d-none');
                } else {
                    $viewMoreCTA.addClass('d-none');
                }
                $this.html(textValue);
            }
        });
    }

    $('.js-view-less').on('click', (e) => {
        const $button = $(e.currentTarget);
        const $component = $button.closest('.right-section');
        const $campaignTextContent = $component.find('.campaign-header__text-block');
        $campaignTextContent.addClass('truncate-text');
        limitText();
        $component.find('.view-less-cta').addClass('d-none');
        $component.find('.view-more-cta').removeClass('d-none');
    });

    limitText();

    $(window).on(
        'orientationchange resize',
        debounce(function () {
            limitText();
        }, 300)
    );
});
